export default __webpack_public_path__ + "static/media/logo.56ea0155.png";